import { Mail } from 'lucide-react';
import { LegalLayout, Lang, Sec, P, Bullets, Divider, CONTACT_EMAIL, SITE_URL } from '@/components/LegalLayout';

const MAILTO = `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent('Delete my account / Usuń moje konto')}`;

export default function DeleteAccount() {
  return (
    <LegalLayout
      title="Usuwanie konta / Delete Account"
      subtitle="Life Leverage OS — Pewnosc Siebie AI"
      updated="Ostatnia aktualizacja / Last updated: czerwiec 2026 / June 2026"
    >
      {/* Primary action */}
      <a
        href={MAILTO}
        data-testid="delete-account-email-button"
        className="btn-brand flex w-full items-center justify-center gap-2 rounded-xl px-4 py-3 text-sm font-semibold text-brand-ink"
      >
        <Mail className="h-4 w-4" /> Wyślij prośbę o usunięcie / Request deletion
      </a>

      <Lang code="PL" label="Polski">
        <Sec title="Jak usunąć konto i dane">
          <P>
            Aby trwale usunąć swoje konto Life Leverage OS oraz wszystkie powiązane dane, wyślij
            wiadomość e-mail na adres {CONTACT_EMAIL} z adresu e-mail powiązanego z Twoim kontem,
            wpisując w temacie „Usuń moje konto / Delete my account”.
          </P>
        </Sec>
        <Sec title="Co zostanie usunięte">
          <Bullets
            items={[
              'dane konta (adres e-mail i profil),',
              'wszystkie Twoje treści: cele, zadania, projekty, nawyki i wpisy finansowe,',
              'konwersacje z Asystentem AI,',
              'przeglądy dzienne oraz pozostałe dane powiązane z kontem.',
            ]}
          />
        </Sec>
        <Sec title="Czas realizacji">
          <P>
            Twoje żądanie potwierdzimy i trwale usuniemy dane w rozsądnym terminie, zwykle w ciągu
            30 dni od weryfikacji prośby.
          </P>
        </Sec>
        <Sec title="Konto demonstracyjne">
          <P>
            Konto demo zawiera wyłącznie przykładowe dane i nie wymaga osobnego usuwania.
          </P>
        </Sec>
        <Sec title="Kontakt">
          <P>
            Pewnosc Siebie AI · {CONTACT_EMAIL} · {SITE_URL}
          </P>
        </Sec>
      </Lang>

      <Divider />

      <Lang code="EN" label="English">
        <Sec title="How to delete your account and data">
          <P>
            To permanently delete your Life Leverage OS account and all associated data, send an
            email to {CONTACT_EMAIL} from the email address linked to your account, with the
            subject “Delete my account / Usuń moje konto”.
          </P>
        </Sec>
        <Sec title="What will be deleted">
          <Bullets
            items={[
              'account data (your email address and profile),',
              'all your content: goals, tasks, projects, habits and finance entries,',
              'your AI Assistant conversations,',
              'daily reviews and other data associated with your account.',
            ]}
          />
        </Sec>
        <Sec title="Processing time">
          <P>
            We will confirm your request and permanently delete your data within a reasonable
            period, usually within 30 days of verifying the request.
          </P>
        </Sec>
        <Sec title="Demo account">
          <P>The demo account contains sample data only and does not require separate deletion.</P>
        </Sec>
        <Sec title="Contact">
          <P>
            Pewnosc Siebie AI · {CONTACT_EMAIL} · {SITE_URL}
          </P>
        </Sec>
      </Lang>
    </LegalLayout>
  );
}
